import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'

import Image from 'components/LegacyImage'
import { STATIC_IMAGE_BASE } from 'libs/constants'

import { trackContactUsClick } from './events'

export const ForBusiness = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <section className='container mc-py-10'>
      <div className='row mc-bg-gray-100 mc-p-8 mc-corners--rounded align-items-center mc-text--center mc-text-md--left'>
        <div className='col-12 col-md-8'>
          <Image
            alt={t('gift.business.imageAlt')}
            src={`${STATIC_IMAGE_BASE}/masterclass-at-work-logo.png`}
            width={247}
            height={20}
            priority
          />
          <p className='mc-mt-4'>{t('gift.business.description')}</p>
        </div>
        <div className='offset-md-1 offset-lg-2 col-md-3 col-lg-2'>
          <Button
            as='a'
            href={paths.enterprisePurchase}
            kind='tertiary'
            onClick={trackContactUsClick}
          >
            {t('gift.business.cta')}
          </Button>
        </div>
      </div>
    </section>
  )
}
